import type ColumnMappingProps from '@Features/data-management/types/ColumnMappingProps'

const uptProps: ColumnMappingProps[] = [
  {
    required: true,
    key: 'hash',
    text: 'Product ID',
  },
  {
    required: true,
    key: 'name',
    text: 'Name',
  },
  {
    key: 'productcode',
    text: 'Product Code',
  },
  {
    key: 'barcode',
    text: 'Barcode',
  },
  {
    key: 'cost',
    text: 'Product Cost',
  },
  {
    key: 'additional_cost',
    text: 'Additional Cost',
  },
  {
    key: 'mineurl',
    text: 'Your Own URL',
  },
]

export default uptProps
